import type {ApplianceAge} from "@prisma/client"

/** Map whole months to the same age bands used by ReportedProductInfo. */
export const applianceAgeBandFromMonths = (months: number): ApplianceAge => {
  if (months < 60) return "LESS_THAN_5_YEARS"
  if (months < 120) return "BETWEEN_5_AND_10_YEARS"
  return "TEN_OR_MORE_YEARS"
}

export const ageMonthsFromInitIntake = (
  initIntake: unknown,
): number | undefined => {
  if (initIntake == null || typeof initIntake !== "object") return undefined
  const months = (initIntake as {applianceAgeMonths?: unknown})
    .applianceAgeMonths
  if (typeof months !== "number" || !Number.isInteger(months) || months < 0) {
    return undefined
  }
  return months
}

/** Brand from Case.initIntake (Bodewell pageContext / initialIntake). */
export const brandFromInitIntake = (
  initIntake: unknown,
): string | undefined => {
  if (initIntake == null || typeof initIntake !== "object") return undefined
  const brand = (initIntake as {brand?: unknown}).brand
  if (typeof brand !== "string") return undefined
  const trimmed = brand.trim()
  return trimmed === "" ? undefined : trimmed
}

/**
 * Prefer initIntake months when they still match the current age band.
 * Drops months if chat later sets a band that disagrees.
 */
export const resolveAgeMonths = (
  initIntake: unknown,
  applianceAge?: ApplianceAge | null,
): number | undefined => {
  const months = ageMonthsFromInitIntake(initIntake)
  if (months == null) return undefined
  if (
    applianceAge != null &&
    applianceAgeBandFromMonths(months) !== applianceAge
  ) {
    return undefined
  }
  return months
}
